import { render } from "./CommonDialog.vue?vue&type=template&id=cbbb200e"
import script from "./CommonDialog.vue?vue&type=script&lang=js"
export * from "./CommonDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductDiagnosis/components/CommonDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cbbb200e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cbbb200e', __exports__)) {
    api.reload('cbbb200e', __exports__)
  }
  
  module.hot.accept("./CommonDialog.vue?vue&type=template&id=cbbb200e", () => {
    api.rerender('cbbb200e', render)
  })

}


export default __exports__